import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Event } from 'src/app/models/event';
import { EventService } from 'src/app/services/event.service';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    standalone: false
})
export class EventsComponent implements OnInit {

  events: Observable<any[]>;
  constructor(private _eventService: EventService) { }

  ngOnInit(): void {
    this.events = this._eventService.list();
  }
  add(event: Event) {
    this._eventService.add(event);
  }
  update(event: Event) {
    this._eventService.update(event);
  }

}
